/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { ICategoryPageContentBlockViewProps } from './category-page-content-block';
import { categoryNamePlacement, layoutOptionsImage } from './category-page-content-block.props.autogenerated';

const _getImageCuts = (imageSizing: layoutOptionsImage, imageData: Msdyn365.IImageData | undefined): string | null => {
    if (!imageData?.src) {
        return null;
    }

    let size;
    if(imageSizing === layoutOptionsImage.small){
        size = `h=200&w=200`
    } else if (imageSizing === layoutOptionsImage.medium){
        size = `h=300&w=300`
    } else {
        size = `h=350&w=350`
    }
    return `${imageData.src}${imageData.src.indexOf('?') > -1 ? '&' : '?'}${size}`;
}


const _renderImage=(categoryImageUrl: Msdyn365.IImageData | undefined, links: Msdyn365.ILinksData, imageSizing: layoutOptionsImage): JSX.Element | null => {
    if(!categoryImageUrl?.src){
        return null;
    }
    let pageLink;
    if(links == undefined || links < 1){
        return (
            <div><img src={_getImageCuts(imageSizing, categoryImageUrl) || ''} alt={categoryImageUrl.altText} className='img-fluid category-image' /></div>
        );
    } else {
        pageLink = links[0].linkUrl.destinationUrl;
        return (
            <a href={pageLink} className="category-a-tag"><img src={_getImageCuts(imageSizing, categoryImageUrl) || ''} alt={categoryImageUrl.altText} className='img-fluid category-image' /></a>
        );
    }
   };

const _renderInfo=(categoryInfo: string, descriptionCustomClass: string): JSX.Element => {
    return (
        <p className={descriptionCustomClass}>{categoryInfo}</p>
    );
};

const _renderEmpty=(): JSX.Element => {
    return(
        <div></div>
    )
}

const _renderName=(categoryName: string, headerStyleContainer: string, middleStyle: React.CSSProperties, links: Msdyn365.ILinksData): JSX.Element => {
    let pageLink;
    if(links == undefined || links < 1){
        return (
            <div>
                <div className={headerStyleContainer} style={middleStyle}>
                    <h2>{categoryName}</h2>
                </div>
            </div>
        )
    } else {
        pageLink = links[0].linkUrl.destinationUrl
        return (
            <a href={pageLink} className="category-a-tag2">
                <div className={headerStyleContainer} style={middleStyle}>
                    <h2>{categoryName}</h2>
                </div>
            </a>
        )
    }
}

export default (props: ICategoryPageContentBlockViewProps) => {
    const { categoryName, categoryInfo, categoryImageUrl, namePlacement, imageSizing, 
            links, headerCustomClass, imageCustomClass, descriptionCustomClass} = props;
    
    //Layouts
    let top;
    let middle;
    let bottom;
    let info;

    //Inline Styles
    let middleStyling: React.CSSProperties;
    let containerStyle: React.CSSProperties;

    //ClassName Changes
    let innerContainer = "category-content-block-container " + imageCustomClass;
    let headerStyleContainer = headerCustomClass;

    if (namePlacement === categoryNamePlacement.middle){
        if (imageSizing === layoutOptionsImage.small){
            containerStyle = {
                display: 'flex',
                position: 'relative',
                width: '200px',
                flexDirection: 'column',
            }
        } 
        else if (imageSizing === layoutOptionsImage.medium){
            containerStyle = {
                display: 'flex',
                position: 'relative',
                width: '300px',
                flexDirection: 'column',
            }
        } else {
            containerStyle = {
                display: 'flex',
                position: 'relative',
                width: '350px',
                flexDirection: 'column',
            }
        }
    } else {
        if (imageSizing === layoutOptionsImage.small){
            containerStyle = {
                display: 'flex',
                position: 'static',
                width: '200px',
                flexDirection: 'column'
            }
        } 
        else if (imageSizing === layoutOptionsImage.medium){
            containerStyle = {
                display: 'flex',
                position: 'static',
                width: '300px',
                flexDirection: 'column'
            }
        } else {
            containerStyle = {
                display: 'flex',
                position: 'static',
                width: '350px',
                flexDirection: 'column'
            }
        }
    }

    if (
        namePlacement === categoryNamePlacement.middle && imageSizing === layoutOptionsImage.small ||
        namePlacement === categoryNamePlacement.middle && imageSizing === layoutOptionsImage.medium ||
        namePlacement === categoryNamePlacement.middle && imageSizing === layoutOptionsImage.large
        ){
        middleStyling = {
            position: 'absolute',
            margin: 'auto',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }
    }
    else{
        middleStyling = {
            position: 'static'
        }
    }

    if (namePlacement === categoryNamePlacement.top){
        top = _renderName(categoryName, headerStyleContainer, middleStyling, links);
        middle = _renderImage(categoryImageUrl, links, imageSizing);
        bottom = _renderEmpty;
        info = _renderInfo(categoryInfo, descriptionCustomClass);
    }
    else if (namePlacement === categoryNamePlacement.middle){
        top = _renderImage(categoryImageUrl, links, imageSizing);
        middle = _renderName(categoryName, headerStyleContainer, middleStyling, links);
        bottom = _renderEmpty;
        info = _renderInfo(categoryInfo, descriptionCustomClass);
    }
    else {
        top = _renderImage(categoryImageUrl, links, imageSizing);
        middle = _renderEmpty;
        bottom = _renderName(categoryName, headerStyleContainer, middleStyling, links);
        info = _renderInfo(categoryInfo, descriptionCustomClass);
    }
    return (
        <div className="outer-category-content-block-container" style={containerStyle}>
            <div className={innerContainer} >
                {top}
                {middle}
            </div>
            <div>
                {bottom}
                {info}
            </div>
        </div>
    );
};
